'use strict';

const { h } = require('phy');

const OfferCalloutImage = require('../../shared/views/offer/offer-callout-image');
const OfferUberImage = require('../../shared/views/offer/offer-uber-image');
const OfferTypeLabel = require('../../shared/views/offer/offer-type-label');
const OfferExpiry = require('../../shared/views/offer/offer-expiry');
const OfferViewTerms = require('../../shared/views/offer/offer-view-terms');
const CouponButton = require('./coupon-button');
const OfferExclusive = require('../../shared/views/offer/offer-exclusive');

function CouponUber({ coupon, routes, lazy = false, color, referralSource }) {
  const ExpiryElement = OfferExpiry({
    className: 'coupon-uber-expiry',
    expires: coupon.expiryDateTime,
  });

  const ExclusiveElement =
    coupon.isExclusive &&
    OfferExclusive({ className: 'coupon-uber-exclusive' });

  return h(
    `.coupon-uber${referralSource ? `.coupon-uber-${referralSource}` : ''}`,
    [
      h(
        '.coupon-uber-callout',
        { style: { backgroundColor: color && `#${color}` } },
        OfferCalloutImage({
          className: 'coupon-uber-callout-image',
          data: coupon && coupon.offerMedia,
          alt: '',
          size: ['w_160,h_80'],
          lazy,
        })
      ),
      h(
        '.coupon-uber-media',
        OfferUberImage({
          className: 'coupon-uber-media-image',
          data: coupon && coupon.offerMedia,
          alt: '',
          size: ['w_462,h_320'],
          lazy,
        })
      ),
      h('.coupon-uber-content', [
        h('h2.coupon-uber-title', coupon.offerTitle),
        ExpiryElement,
        h('.coupon-uber-info', [
          OfferTypeLabel({ coupon, className: 'coupon-uber-type' }),
          ExclusiveElement,
        ]),
        h('.coupon-uber-action', [
          OfferViewTerms({
            routes,
            offerId: coupon.offerId,
            className: 'coupon-uber-terms',
          }),
          CouponButton({
            coupon,
            routes,
            className: 'coupon-uber-button',
            referralSource,
          }),
        ]),
      ]),
    ]
  );
}

module.exports = CouponUber;
